import { useQueryClient } from "@tanstack/react-query";

import {
  getGetOnDemandTasksQueryKey,
  useGetOnDemandTasks,
} from "@vega-api/generated/lp-tasks/lp-tasks";
import type { LpTaskResponse } from "@vega-api/generated/types/lpTaskResponse";
import { TaskPlacement } from "@vega-api/generated/types/taskPlacement";

export const useSettingsFeedbackTasks = () => {
  const queryClient = useQueryClient();
  const { data, isLoading } = useGetOnDemandTasks();

  const tasks: LpTaskResponse[] = (data?.data ?? [])
    .filter((task) => task.placement === TaskPlacement.SETTINGS_FEEDBACK)
    .sort((first, second) => first.displayOrder - second.displayOrder);

  const invalidate = () =>
    queryClient.invalidateQueries({
      queryKey: getGetOnDemandTasksQueryKey(),
    });

  return { tasks, hasTasks: tasks.length > 0, isLoading, invalidate };
};
